module.exports = __webpack_public_path__ + "public/Icons/getStartedArrowDark.svg?9ff03da3";